angular.module('env.userSettings', [])

    .provider('userSettings', function ($localStorageProvider) {

        var _this = this;
        var userSettingsKey = "om.userSettings";
        var initPromise;
        var returnLocalPromise;

        /**
         * User settings object
         */
        var settings;

        /**
         * Save current settings to local storage
         */
        function saveSettings() {
            var settingsToSave = settings || {};
            $localStorageProvider.setItem(userSettingsKey, settingsToSave);
            return settingsToSave;
        }

        function getSettings() {
            return initPromise.then(function(s) {
                return settings; //Returning 'settings' here to make sure we don't miss any change on settings object done by other callers
            });
        }

        _.extend(_this, {
            save: saveSettings,
            getSettings: getSettings
        });

        this.$get = function (customResourceResolver, $localStorage, $q) {

            initSettings();

            return _this;

            function initSettings() {
                initPromise = customResourceResolver.resolveConfig("defaultUserSettings-config", null)
                    .then(function(customDefaultUserSettings) {
                        var versionFromDefaultConfig = om.config.defaultUserSettings.version || 0;
                        var versionFromCustomConfig = (customDefaultUserSettings && !_.isEqual(customDefaultUserSettings, {})) ? (customDefaultUserSettings.version || 0) : 0;
                        var versionFromSaved = 0;

                        //See if we have stored settings locally
                        var settingsToUse = $localStorage.getItem(userSettingsKey);
                        if (settingsToUse && !_.isEqual(settingsToUse, {})) {
                            versionFromSaved = settingsToUse.version || 0;
                            if (versionFromSaved >= versionFromCustomConfig && versionFromSaved >= versionFromDefaultConfig) {
                                settings = _.clone(settingsToUse);
                                return settings;
                            }
                        }
                        
                        //As we have no settings stored locally, use the customized default version, or, if not present, global default settings
                        if (customDefaultUserSettings && !_.isEqual(customDefaultUserSettings, {}) && versionFromCustomConfig >= versionFromDefaultConfig) {
                            settings = _.clone(customDefaultUserSettings);
                        } else {
                            settings = _.clone(om.config.defaultUserSettings);
                        }
                        
                        return settings;
                    });

                return initPromise;
            }
        }
    });
